import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Button, Card, Descriptions, Image, Input, Popconfirm, Space, Switch, Table, Tag, Tooltip, } from 'antd'
import '../../style/page.css'
import { EyeIcon, SearchIcon, TrashIcon, } from 'lucide-react';
import Tables from '../../component/Tables';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentHistory, setPagination, setSearchParams } from '../../feature/dayCare/paymentHistorySlice';
import { getTransactionStatus } from '../../constant/Constatnt';

function PaymentHisory() {
    const [value, setValue] = useState("");
    const [loadingId, setLoadingId] = useState(null);
    const dispatch = useDispatch()
    const { paymentHistory, isLoading, totalPage, limit, current, searchParams } = useSelector((state) => state.payments);

    const columns = [
        {
            title: 'Transaction ID',
            dataIndex: 'stripePaymentIntentId',
            key: 'stripePaymentIntentId',
            ellipsis: true,
            render:
                (_, { stripePaymentIntentId }) => <strong>{stripePaymentIntentId}</strong>
        },
        {
            title: 'Daycare Name',
            dataIndex: 'daycareName',
            key: 'daycareName',
            ellipsis: true,
        },
        {
            title: 'Paid Amount',
            dataIndex: 'paidAmount',
            key: 'paidAmount',
            ellipsis: true,
            render:
                (_, { paidAmount, currency }) => <p>{paidAmount} ({currency?.code})</p>
        },
        {
            title: 'Plan',
            dataIndex: 'planName',
            key: 'planName',
            ellipsis: true,
        },
        {
            title: 'Plan Date',
            dataIndex: 'planStartDate',
            key: 'planStartDate',
            ellipsis: true,
            render:
                (_, { planStartDate }) => <Tag color='green'>{planStartDate}</Tag>
        },
        {
            title: 'Expiry Date',
            dataIndex: 'planExpiryDate',
            key: 'planExpiryDate',
            ellipsis: true,
            render:
                (_, { planExpiryDate }) => <Tag color='red'>{planExpiryDate}</Tag>
        },

        {
            title: 'Payment Date',
            dataIndex: 'paymentDate',
            key: 'paymentDate',
            ellipsis: true,
        },
        {
            title: 'Status',
            dataIndex: 'paymentStatus',
            key: 'paymentStatus',
            ellipsis: true,
            fixed:
                'right',
            render: (_, { paymentStatus }) => <Tag color={getTransactionStatus(paymentStatus)} bordered={false}>{paymentStatus}</Tag>
        },

    ];

    const handlePagination = (page) => {
        dispatch(setPagination(page))
    };

    useEffect(() => {
        dispatch(getPaymentHistory({ current, limit, searchParams }));
    }, [current, searchParams])

    const props = {
        columns, tableData: paymentHistory, current, handlePagination, totalPage, isLoading
    }

   
    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }

    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.payment}</p>
                    <Space>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                <Tables {...props} />
            </div>
        </section >
    )
}

export default PaymentHisory